import {Content} from "pdfmake/interfaces";
import {ItemI} from "../../../../shared";
import {defPDFHeader} from "../../partsOfPage";
import {SectionListElement} from "../../getPDFPages";
import {ColorsItemsInterface} from "../../../../store/types/store";
import {getColorsBlock} from "./parts/getColors";
import {GeneralSpecification} from "../../../MainMenu/Panels/SpecificationPanel/utils";
import {getJSONForGeneralSpecification} from "./parts/generalSpecification/getJSONForGeneralSpecification";
import {getJSONForSpecification} from "./parts/specification/getJSONForSpecification";

export const getSpecificationPages = (sectionList: SectionListElement[],
                                      parts: ItemI[],
                                      colorsItems: ColorsItemsInterface,
                                      generalSpecification?: GeneralSpecification): Content => {
    const content: Content = []
    content.push(JSON.parse(JSON.stringify(defPDFHeader)));

    if (generalSpecification) {
        //Общая спецификация
        content.push(getJSONForGeneralSpecification(generalSpecification, parts))
    } else {
        //Спецификация таблицей
        content.push(getJSONForSpecification(sectionList, parts))
    }
    content.push(getColorsBlock(colorsItems))
    return content
}
